/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Data_Collected_S32_TitleInputs */

const es_privacy_policy_data_collected_s32_title = /** @type {(inputs: Privacy_Policy_Data_Collected_S32_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3.2 Informacion que recopilamos automaticamente`)
};

const en_privacy_policy_data_collected_s32_title = /** @type {(inputs: Privacy_Policy_Data_Collected_S32_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3.2 Information We Collect Automatically`)
};

/**
* | output |
* | --- |
* | "3.2 Information We Collect Automatically" |
*
* @param {Privacy_Policy_Data_Collected_S32_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_data_collected_s32_title = /** @type {((inputs?: Privacy_Policy_Data_Collected_S32_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Data_Collected_S32_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_data_collected_s32_title(inputs)
	return en_privacy_policy_data_collected_s32_title(inputs)
});
export { privacy_policy_data_collected_s32_title as "privacy_policy.data_collected.s32_title" }